import axios from 'axios';
import { variables } from './variables.js';
import axiosInstance from './axiosInstance';

const API_URL = variables.PRODUCT_API

const getProducts = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `${API_URL}?${queryString}`;
  const response = await axiosInstance.get(url);
  return response.data;
}

const getProduct = async (params) => {
  const queryString = params ? `${params}` : '';
  const response = await axiosInstance.get(`${API_URL}/${queryString}`);
  return response.data;
}

const addProduct = async (product) => {
  const response = await axios.post(API_URL, product);
  return response.data;
}

const updateProduct = async (productId, product) => {
  const response = await axios.put(`${API_URL}/${productId}`, product);
  return response.data;
}

const deleteProduct = async (productId) => {
  const response = await axios.delete(`${API_URL}/${productId}`);
  return response.data;
}

export default {
  getProducts,
  getProduct,
  addProduct,
  updateProduct,
  deleteProduct
};